import type { FC } from 'react';
import { useLocation } from 'react-router';

import useRole from '@zen/Auth/hooks/useRole';
import useAccountPermissions from '@zen/Auth/useAccountPermissions';
import useGlobalPermissions from '@zen/Auth/useGlobalPermissions';
import { Role } from '@zen/Networks/types';
import { NEW_BOOKING_ROUTE_PREFIX } from '@zen/Routes/newBooking';

import BookingButton from './BookingButton';
import BookingRequestButton from './BookingRequestButton';

const BookingButtonContainer: FC = () => {
  const role = useRole();
  const { pathname, search } = useLocation();
  const { check } = useGlobalPermissions();
  const { check: accountCheck } = useAccountPermissions();

  const isBookingPage: boolean = pathname.includes(NEW_BOOKING_ROUTE_PREFIX) || search.includes('booking=true');
  const canCreateBooking: boolean =
    role !== Role.AGENT_FORWARDER ? accountCheck('bookings.canCreate') : check('bookings.canCreate');
  const canRequestBooking: boolean = check('bookings.canRequest');
  const legacyCanRequestBooking: boolean = canRequestBooking && role === Role.MANUFACTURER;

  if (isBookingPage) {
    return null;
  }

  if (canCreateBooking) {
    return <BookingButton canRequestBooking={canRequestBooking} />;
  }

  return legacyCanRequestBooking ? <BookingRequestButton /> : null;
};

export default BookingButtonContainer;
